module.exports = __webpack_public_path__ + "static/media/miningtrade.d27928d9.png";